import * as app from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyD_cjvTuBY362yT9losTxG3jEsz2K19AvM',
  authDomain: 'stoic-quotes-amar.firebaseapp.com',
  databaseURL: 'https://stoic-quotes-amar.firebaseio.com',
  projectId: 'stoic-quotes-amar',
  storageBucket: 'stoic-quotes-amar.appspot.com',
  messagingSenderId: '515374512934',
  appId: '1:515374512934:web:1a5ad94d2e4c3ca1ed9fe7',
  measurementId: 'G-REM6XGFW9Q',
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.firestore();
  }

  register = (email, password, cb) => {
    this.auth
      .createUserWithEmailAndPassword(email, password)
      .then((value) => {
        cb();
      })
      .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage);
      });
  };

  login = (email, password, cb) => {
    this.auth
      .signInWithEmailAndPassword(email, password)
      .then((value) => {
        cb();
      })
      .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage);
      });
  };

  logout = (cb) => {
    this.auth
      .signOut()
      .then((value) => cb())
      .catch(function (error) {
        var errorCode = error.code;
        var errorMessage = error.message;
        alert(errorMessage);
      });
  };

  isInitialized() {
    return new Promise((resolve) => {
      this.auth.onAuthStateChanged(resolve);
    });
  }

  getCurrentEmail() {
    return this.auth.currentUser && this.auth.currentUser.email;
  }

  currentUser() {
    return this.auth.currentUser;
  }

  isLoggedIn() {
    return this.auth.currentUser != null;
  }

  setData(collection, doc, data) {
    return this.db.collection(collection).doc(doc).set(data);
  }

  getData(collection, doc) {
    return this.db.collection(collection).doc(doc).get();
  }
}

export default new Firebase();
